export default __webpack_public_path__ + "static/media/logo.f7d7b334.png";